export default class SideBarActions {
    public static TOGGLE_SIDEBAR: string = 'TOGGLE_SIDEBAR';
    public static SHOW_SIDEBAR: string = 'SHOW_SIDEBAR';
    public static HIDE_SIDEBAR: string = 'HIDE_SIDEBAR';
}
